import {AutocompleteError, BacktoAllJobs, Button, ButtonStyle, clearSWRCache, cursorNone, CloseIcon, Field, FieldArray, Form, Formik, FormikControl, goToNextPage, getCompetenciesList,
        getScorecardData, getSuggestionValue, hideDraft, handleCompentencyFormSubmit, Image, InputError, onAddClick, jobStatusBadge, JOB_STEPS, Link, motion, NextServerCookies, onSuggestionsFetchRequested, onSuggestionsClearRequested, PAGE_ANIMATION_OPTIONS,
        PageStyle, EditScorecardStyle, React, renderSuggestion, REDIRECT, shouldRenderSuggestions, useEffect, useQueryClient, useRouter, useState, useSWR, previewJob, DataFromUrl, useTranslation, ScorecardAction, Autosuggest, ClientDashboard, ArrowLeft,SIDEBAR_OPTIONS, JOB_STEPS_BACKEND,
        SidebarAction, sendToCurrentSteps, INITIAL_VALUES, VALIDATION_SCHEMA, COMPETENCY_ATTRIBUTES_HASH, useRef, CreateJobScorecardComponent, CreateJobAddScorecardLinkComponent, Checkbox, Tooltip, ScorecardImportModal, DownloadIcon, AddScorecardAction, Loading} from '@/imports-files/pages/clients/jobs/new-edit-scorecard.js';
import {GetNameFromHash} from '@/actions/common/competencyName/getCompetencySubCompetencyName';
import { showAddScorecard, hideAddScorecard } from "@/imports-files/pages/clients/jobs/candidate-profile-job.js";


import Rating from "react-rating";
import InfoIcon from 'public/icons/info.svg'
import OneRating from 'public/images/pages/scorecard/ratings/rating1.svg';
import TwoRating from 'public/images/pages/scorecard/ratings/rating2.svg';
import ThreeRating from 'public/images/pages/scorecard/ratings/rating3.svg';
import FourRating from 'public/images/pages/scorecard/ratings/rating4.svg';
import FiveRating from 'public/images/pages/scorecard/ratings/rating5.svg';


// Sub Competency Icons
import OneSubRating from 'public/images/pages/scorecard/ratings/sub-rating1.svg';
import TwoSubRating from 'public/images/pages/scorecard/ratings/sub-rating2.svg';
import ThreeSubRating from 'public/images/pages/scorecard/ratings/sub-rating3.svg';
import FourSubRating from 'public/images/pages/scorecard/ratings/sub-rating4.svg';
import FiveSubRating from 'public/images/pages/scorecard/ratings/sub-rating5.svg';



function NewEditScorecard(props)
{
  const [competencies, setCompetencies]                   =   useState([]);
  const [competenciesCount, setCompetenciesCount]         =   useState('');
  const [job_status, setJobStatus]                        =   useState("open");
  const router                                            =   useRouter();
  const [isLoading, setLoading]                           =   useState(true);
  const [initialValues, setInitialValues]                 =   useState('');
  const [cancelPopup, setCancelPopup]                     =   useState(false);
  const queryClient                                       =   useQueryClient();
  const current_step                                      =   JOB_STEPS.SCORECARDS
  const [submitState, setSubmitState]                     =   useState('');
  const [jobPreview, setJobPreivew]                       =   useState({});
  const [showLoader, setShowLoader] = useState(false)
  const sidebarAction                                     =   new SidebarAction(queryClient, router);
  const [scoreCardImport, setScoreCardImport]                     = useState(false);
  const { t, i18n }                                       =   useTranslation();
  var jobId                                               =   new DataFromUrl().getJobId();
  const [gotoKanban, setGotoKanban]                       =   useState(false);
  const [flagForRender, setFlagForRender]                 =   useState(false);
  const fromKanban                                        =   router.query.from_kanban ? true : false;
  let [editable, setEditable]                             =   useState(true);
  const [disabledSaveButton, setDisabledSaveButton]       =   useState(false);
  const [submitButtonDisabled, setSubmitButtonDisabled] = useState(false);
  const formRef                                           =   useRef();
  const [clientId, setClientId]                           =   useState();
  const scorecardAction                                   =   new ScorecardAction(formRef, initialValues, setFlagForRender);
  const addScorecardAction                                 = new AddScorecardAction(router);
  const getNameFromHash = new GetNameFromHash();
  const [isDirtyArray, setDirtyArray]                     =   useState(false)
  var gIndex = 0

  useEffect(() => {
                    setLoading(false);
                  },[props.selectScorecardIndex, props.flagForRender]);

    if(isLoading)
    {
      return null;
    }

    const renderInputComponent = inputProps => (
        <input className = {PageStyle.Form__Input} autoComplete={"password"}
        {...inputProps} />
    );

    function getScoreColor(score, isLight){
      let scoreValue = parseFloat(score)
      if(scoreValue == NaN)
        return isLight ? 'LightRedBg' : 'RedBg'
      else if(scoreValue <= 2)
        return isLight ? 'LightRedBg' : 'RedBg'
      else if(scoreValue > 2 && scoreValue < 4)
        return isLight ? 'LightYellowBg' : 'YellowBg'
      else if(scoreValue >= 4)
        return isLight ? 'LightGreenBg' : 'GreenBg'
      else
        return isLight ? 'LightRedBg' : 'RedBg'
    }

    function pageBreakIndex(index, subIndex, gIndex) {
      return 'pagebreaks'
      // return (subIndex % 3 == 0) ? 'pagebreaks' : 'nopagebreak'
      // if(index == 0){
      //   return subIndex == 0 ? 'nopagebreak' : ((subIndex) % 3 == 0 ? 'pagebreaks' : '')
      // }else{
      //   return subIndex == 1 ? 'nopagebreak' : (subIndex == 2 ? '' : (subIndex+2) % 3 == 0 ? 'pagebreaks' : '')
      // }

    }

    function pageBreak(){
      gIndex = gIndex + 1
      return gIndex % 3 == 0 ? 'pagebreak' : ''
    }

    const radiusClass = (competencyCount) => { return competencyCount > 0 ? '' : EditScorecardStyle.Radius20 }
  return (
    <div className={`DashboardPageContent`}>
      <motion.div initial="pageInitial"  animate="pageAnimate"  exit="pageExit"  variants={PAGE_ANIMATION_OPTIONS}  transition={{ delay: 0.2}}>
        <div className={`Page Score ${PageStyle.Scorecards} job-form-section`}>
             <BacktoAllJobs/>
            <div className={`${PageStyle.NewJob__Container} ${EditScorecardStyle.EditContainer}`}>
            <Formik
              initialValues={addScorecardAction.setFormInitialValues(props.initialData, props.selectScorecardIndex)}
              innerRef={formRef}
              onSubmit={(values) => {
                  addScorecardAction.submitForm(values, props.setShowScorecardPopup, props.setFlagForRerender, props, setSubmitButtonDisabled, hideAddScorecard, setShowLoader)
              }}
            >
            {(formik) => (
              <Form className={PageStyle.Form}>
              {!props.isPublic && <div className={`${EditScorecardStyle.CreateScoreCard__TopSection} noprint`}>
                <div className={`${PageStyle.ClientCompany__BackSection} w100`} onClick={()=> { props.setSelectScorecardIndex(undefined); setLoading(true);  hideAddScorecard(); }}>
                  <ArrowLeft />
                  <span className={`ml15`}>Back to Candidate Profile</span>
                </div>
                <div className = {EditScorecardStyle.CreateScoreCard__DownloadAndSubmit}>
                    <Button buttonstyle={`${ButtonStyle.secondarybtnborder} ${EditScorecardStyle.DownloadBtn}`} onClick={()=> {
                      window.print();
                    }}><span className = {`mr5`}><DownloadIcon/></span> Download Template</Button>
                    <Button buttonstyle={`${ButtonStyle.secondarybtn} ml10`} onClick={() => formRef.current.submitForm()}>SUBMIT</Button>
                </div>
              </div>}
              <div className={`${PageStyle.ClientCompany__FormSection}`}>
                <div className = {`${EditScorecardStyle.ClientCompany__FormSection}`}>
                  <div className = {`${EditScorecardStyle.ClientCompany__LeftContent}`}>
                    {!props.isPublic && <h4 className={` ${EditScorecardStyle.ClientCompany__SmallHeading} ${PageStyle.ClientCompany__StatusAlignment} noprint`}>
                    { typeof props.selectScorecardIndex != 'undefined' ? 'Edit Scorecard' : 'New Scorecard'}</h4>}
                      <h1 className={` ${EditScorecardStyle.ClientCompany__Heading} ${PageStyle.ClientCompany__StatusAlignment} mb0`}>{props.initialData.application.name}</h1>
                      <h1 className={` ${EditScorecardStyle.ClientCompany__Heading} ${PageStyle.ClientCompany__StatusAlignment} ${EditScorecardStyle.ClientCompany__JobTitleHeading} mt10 mb0 printData displaynone`}>{props.initialData.application.job_title}</h1>
                  </div>
                </div>
              </div>
              <div className = {`w100 mt35`}>
                <div className={`${EditScorecardStyle.CreateScoreCard}`}>
                  {formik.values.scorecard.score_hash.map( (competency, index) => {
                    return (<div key={`competency_${index}`} className={`${EditScorecardStyle.CreateScoreCard__Card}`}>
                    <div className={`${EditScorecardStyle.LightBox}`}>
                      <div className={`${EditScorecardStyle.LightBox__Competency} ${radiusClass(competency.job_sub_competencies.length)} ${pageBreak()}`}>
                        <div className = {`${EditScorecardStyle.LeftContent}`}>
                          <div className={`${EditScorecardStyle.CompetencyNotes}`}>
                            <h2>{getNameFromHash.getCompetencyName(competency.job_competency_id, props.initialData.competencies)}</h2>
                            <p>{getNameFromHash.getCompetencyNotes(competency.job_competency_id, props.initialData.competencies)}</p>
                          </div>
                        </div>
                        <div className = {`${EditScorecardStyle.RightContent}`}>
                            {competency.job_sub_competencies.length > 0 ? <div className ={`${EditScorecardStyle.AverageScore} noprint`}>
                              <p>Average Score</p>
                              {addScorecardAction.calculateOverallScore(competency.job_sub_competencies) != 0 ? <div className = {`${EditScorecardStyle.AverageScore__Value} ${addScorecardAction.getOverallScoreColor(competency.job_sub_competencies)} `}>
                                <span className = {`Average__Score`}>{addScorecardAction.calculateOverallScore(competency.job_sub_competencies)}</span>
                              </div> : '--'}
                            </div>
                            :<div className={`${EditScorecardStyle.Rating} CompetencyScorecardRating CompetencyScorecardRating_${index} noprint`}>
                              <Rating onHover={(value)=>{addScorecardAction.colorHoverRatingSymbolArray(value, `CompetencyScorecardRating_${index}`, 'competency_color', formik.values.scorecard.score_hash[index].score)}}
                                                          onChange={(value)=>{addScorecardAction.onChangeRating(`scorecard.score_hash.${index}.score`, formik, value, `CompetencyScorecardRating_${index}`, 'competency_color')}}
                                                          emptySymbol={[<OneRating/>,<TwoRating/>,<ThreeRating/>,<FourRating/>,<FiveRating/>].map(rating => <span className={`${PageStyle.Modal__Card__Rating} EmptyRating`}>{rating}</span>)}
                                                          fullSymbol={addScorecardAction.initalArray(formik.values.scorecard.score_hash[index].score, 'competency').map(fillRating => <span className={`${PageStyle.Modal__Card__Rating} FillRating`}>{fillRating}</span>)}
                                                          initialRating={formik.values.scorecard.score_hash[index].score}
                                                    />
                              <div className = {`${EditScorecardStyle.PoorExcellentText}`}>
                                <div className = {`${EditScorecardStyle.PoorExcellentText__LeftContent} w100`}>
                                  <span>Poor</span>
                                </div>
                                <div className = {`${EditScorecardStyle.PoorExcellentText__RightContent} w100`}>
                                  <span>Excellent</span>
                                </div>
                              </div>
                            </div>}

                            {competency.job_sub_competencies.length > 0 ? <div className ={`${EditScorecardStyle.AverageScore} printData displaynone`}>
                              <p>Average Score</p>
                            </div>
                            :<div className={`${EditScorecardStyle.Rating} CompetencyScorecardRating CompetencyScorecardRating_${index} printData displaynone`}>
                              <Rating onHover={(value)=>{addScorecardAction.colorHoverRatingSymbolArray(value, `CompetencyScorecardRating_${index}`, 'competency_color', formik.values.scorecard.score_hash[index].score)}}
                                                          onChange={(value)=>{addScorecardAction.onChangeRating(`scorecard.score_hash.${index}.score`, formik, value, `CompetencyScorecardRating_${index}`, 'competency_color')}}
                                                          emptySymbol={[<OneRating/>,<TwoRating/>,<ThreeRating/>,<FourRating/>,<FiveRating/>].map(rating => <span className={`${PageStyle.Modal__Card__Rating} EmptyRating`}>{rating}</span>)}
                                                          fullSymbol={[<OneRating/>,<TwoRating/>,<ThreeRating/>,<FourRating/>,<FiveRating/>].map(rating => <span className={`${PageStyle.Modal__Card__Rating} EmptyRating`}>{rating}</span>)}
                                                          initialRating={formik.values.scorecard.score_hash[index].score}
                                                    />
                              <div className = {`${EditScorecardStyle.PoorExcellentText}`}>
                                <div className = {`${EditScorecardStyle.PoorExcellentText__LeftContent} w100`}>
                                  <span>Poor</span>
                                </div>
                                <div className = {`${EditScorecardStyle.PoorExcellentText__RightContent} w100`}>
                                  <span>Excellent</span>
                                </div>
                              </div>
                            </div>}


                            <div className = {`${EditScorecardStyle.TextEditor} removeplaceholder noprint`}>
                            <FormikControl
                              control="customtextarea"
                              type="text"
                              formik={``}
                              className={`${EditScorecardStyle.Form__Textarea}`}
                              name={`scorecard.score_hash.${index}.info`}
                              rows="4"
                              placeholder={`Add Notes...`}
                            />
                          </div>
                          <div className = {`${EditScorecardStyle.TextEditor} removeplaceholder printData displaynone`}>
                            <FormikControl
                              control="customtextarea"
                              type="text"
                              formik={``}
                              className={`${EditScorecardStyle.Form__Textarea}`}
                              name={`scorecard.empty`}
                              rows="4"
                              placeholder={`Add Notes...`}
                            />
                          </div>
                          </div>
                        </div>


                        {/**** Sub competency ****/}
                      <div className={`${EditScorecardStyle.CreateScoreCard__SubCompetency} printHeader`}>
                        {competency.job_sub_competencies.map((subcompetency, subIndex) => {
                          return (
                            <div key={`competency__${index}__subcompetency__${subIndex}`}  className = {`${EditScorecardStyle.SingleSubCompetency} w100 ${pageBreak()}`}>
                              <div className = {`${EditScorecardStyle.LeftContent}`}>
                                <div className={`${EditScorecardStyle.SubCompetencyNotes}`}>
                                  <h2>{getNameFromHash.getSubCompetencyName(subcompetency.job_sub_competency_id, props.initialData.competencies)}</h2>
                                  <p>{getNameFromHash.getSubCompetencyNotes(subcompetency.job_sub_competency_id, props.initialData.competencies)}</p>
                                </div>
                              </div>
                              <div className = {`${EditScorecardStyle.RightContent}`}>
                                <div className ={`${EditScorecardStyle.Rating} CompetencyScorecardRating_${index}_SubCompetencyScorecardRating_${subIndex} noprint`}>
                                    {/* <Rating /> */}
                                    <Rating onHover={(value)=>{addScorecardAction.colorHoverRatingSymbolArray(value, `CompetencyScorecardRating_${index}_SubCompetencyScorecardRating_${subIndex}`, 'subcompetency_color', formik.values.scorecard.score_hash[index].job_sub_competencies[subIndex].score)}}
                                                            onChange={(value)=>{addScorecardAction.onChangeRating(`scorecard.score_hash.${index}.job_sub_competencies.${subIndex}.score`, formik, value, `CompetencyScorecardRating_${index}_SubCompetencyScorecardRating_${subIndex}`, 'subcompetency_color')}}
                                                            emptySymbol={[<OneSubRating/>,<TwoSubRating/>,<ThreeSubRating/>,<FourSubRating/>,<FiveSubRating/>].map(rating => <span className={`${PageStyle.Modal__Card__Rating} EmptyRating`}>{rating}</span>)}
                                                              fullSymbol={addScorecardAction.initalArray(formik.values.scorecard.score_hash[index].job_sub_competencies[subIndex].score, 'subcompetency').map(fillRating => <span className={`${PageStyle.Modal__Card__Rating} FillRating`}>{fillRating}</span>)}
                                                              initialRating={formik.values.scorecard.score_hash[index].job_sub_competencies[subIndex].score}
                                                        />
                                      <div className = {`${EditScorecardStyle.PoorExcellentText}`}>
                                        <div className = {`${EditScorecardStyle.PoorExcellentText__LeftContent} w100`}>
                                          <span>Poor</span>
                                        </div>
                                        <div className = {`${EditScorecardStyle.PoorExcellentText__RightContent} w100`}>
                                          <span>Excellent</span>
                                        </div>
                                      </div>
                                  </div>
                                  <div className ={`${EditScorecardStyle.Rating} CompetencyScorecardRating_${index}_SubCompetencyScorecardRating_${subIndex} printData displaynone`}>
                                    {/* <Rating /> */}
                                    <Rating onHover={(value)=>{addScorecardAction.colorHoverRatingSymbolArray(value, `CompetencyScorecardRating_${index}_SubCompetencyScorecardRating_${subIndex}`, 'subcompetency_color', formik.values.scorecard.score_hash[index].job_sub_competencies[subIndex].score)}}
                                                            onChange={(value)=>{addScorecardAction.onChangeRating(`scorecard.score_hash.${index}.job_sub_competencies.${subIndex}.score`, formik, value, `CompetencyScorecardRating_${index}_SubCompetencyScorecardRating_${subIndex}`, 'subcompetency_color')}}
                                                            emptySymbol={[<OneSubRating/>,<TwoSubRating/>,<ThreeSubRating/>,<FourSubRating/>,<FiveSubRating/>].map(rating => <span className={`${PageStyle.Modal__Card__Rating} EmptyRating`}>{rating}</span>)}
                                                              fullSymbol={[<OneSubRating/>,<TwoSubRating/>,<ThreeSubRating/>,<FourSubRating/>,<FiveSubRating/>].map(rating => <span className={`${PageStyle.Modal__Card__Rating} EmptyRating`}>{rating}</span>)}
                                                              initialRating={formik.values.scorecard.score_hash[index].job_sub_competencies[subIndex].score}
                                                        />
                                      <div className = {`${EditScorecardStyle.PoorExcellentText}`}>
                                        <div className = {`${EditScorecardStyle.PoorExcellentText__LeftContent} w100`}>
                                          <span>Poor</span>
                                        </div>
                                        <div className = {`${EditScorecardStyle.PoorExcellentText__RightContent} w100`}>
                                          <span>Excellent</span>
                                        </div>
                                      </div>
                                  </div>
                                  <div className = {`${EditScorecardStyle.TextEditor} removeplaceholder noprint`}>
                                  <FormikControl
                                    control="customtextarea"
                                    type="text"
                                    formik={``}
                                    className={`${EditScorecardStyle.Form__Textarea}`}
                                    name={`scorecard.score_hash.${index}.job_sub_competencies.${subIndex}.info`}
                                    rows="4"
                                    placeholder={`Add Notes...`}
                                  />
                                </div>
                                <div className = {`${EditScorecardStyle.TextEditor} removeplaceholder printData displaynone`}>
                                  <FormikControl
                                    control="customtextarea"
                                    type="text"
                                    formik={``}
                                    className={`${EditScorecardStyle.Form__Textarea}`}
                                    name={`scorecard.empty`}
                                    rows="4"
                                    placeholder={`Add Notes...`}
                                  />
                                </div>
                              </div>
                            </div>
                            )
                        })}
                      </div>
                    </div>
                  </div>)})}

                </div>
              </div>

              <div className={`${PageStyle.Modal__Card__Editor} CustomEditor mt30 noprint`}>
                <FormikControl
                  control="customtextarea"
                  type="text"
                  formik={formik}
                  className    = {`${PageStyle.Form__Textarea} width100 bs-none`}
                  rows         =   "7"
                  placeholder  = "Questions still to be asked or have some overall feedback (Optional)"
                  name         = {"scorecard.overall_feedback"}
                />
              </div>
              <div className={`${PageStyle.Modal__Card__Editor} CustomEditor mt30 printData displaynone`}>
                <FormikControl
                  control="customtextarea"
                  type="text"
                  formik={formik}
                  className    = {`${PageStyle.Form__Textarea} width100 bs-none`}
                  rows         =   "7"
                  placeholder  = "Questions still to be asked or have some overall feedback (Optional)"
                  name         = {"scorecard.empty_overall_feedback"}
                />
              </div>
              </Form>
              )}
              </Formik>
              {<div className = {`${EditScorecardStyle.CreateScoreCard__DownloadAndSubmit} mt20 noprint`}>
                 {props.isPublic && <Button buttonstyle={`${ButtonStyle.secondarybtnborder} ${EditScorecardStyle.DownloadBtn}`} onClick={()=> {
                      window.print();
                    }}><span className = {`mr5`}><DownloadIcon/></span> Download Template</Button>}
                {!props.isPublic && <Button buttonstyle={`${ButtonStyle.secondarybtn} ml10 displaynone1`} onClick={() => formRef.current.submitForm()}>SUBMIT</Button>}
              </div>}
            </div>
          </div>
      </motion.div>
      { showLoader && <Loading />}
    </div>
  );
}


NewEditScorecard.layout = ClientDashboard;
export default NewEditScorecard;
